"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseEnvironmentVariable = exports.getEnvironmentVariable = exports.getNameFromClassInstance = void 0;
const errors_1 = require("@seneca/errors");
function getNameFromClassInstance(instance) {
    try {
        return instance.constructor.name;
    }
    catch (err) { }
    return undefined;
}
exports.getNameFromClassInstance = getNameFromClassInstance;
/**
 * Gets a variable from the environment. Throws if the variable does not exist.
 */
function getEnvironmentVariable(name) {
    if (!process.env[name]) {
        throw new errors_1.MissingArgumentError(`Missing ${name} env var`);
    }
    return process.env[name];
}
exports.getEnvironmentVariable = getEnvironmentVariable;
function parseEnvironmentVariable(name) {
    const value = getEnvironmentVariable(name);
    try {
        return JSON.parse(value);
    }
    catch (err) {
        throw new errors_1.DeveloperMisconfigurationError(`Could not parse ${name}. Received value: ${value}. Err: ${err}`);
    }
}
exports.parseEnvironmentVariable = parseEnvironmentVariable;
